import { City } from "./city";
import { Customer } from "./customer";


export class CustomerDeliveryDetails {

    refNo: number;
    customerCode: string;

    shippingAddress: string;
    shippingPlotNo: string;
    shippingStreet: string;
    shippingCityCode: string;
    shippingLandMark: string;
    shippingPinCode: string;

    contactMobile: string;
    contactName: string;

    longitude: number;
    latitude: number;

    customer: Customer;
    shippingCity: City;

    defaultAddress: boolean;
}
